document.addEventListener('DOMContentLoaded', function() {
  const handleFilterUpdate = (form, collectionHandle) => {
    const formData = new FormData(form);
    const currentParams = new URLSearchParams(window.location.search);

    // Add existing search params to formData, ensuring multiple selections are handled correctly
    currentParams.forEach((value, key) => {
      if (formData.has(key)) {
        if (!formData.getAll(key).includes(value)) {
          formData.append(key, value);
        }
      } else {
        formData.set(key, value);
      }
    });

    const queryString = new URLSearchParams(formData).toString();

    fetch(`/collections/${collectionHandle}?${queryString}`)
      .then(response => response.text())
      .then(data => {
        let html_div = document.createElement('div');
        html_div.innerHTML = data;

        // Update filters without changing order
        const newFilters = html_div.querySelectorAll('.normal-filter');
        const currentFilters = document.querySelectorAll('.normal-filter');
        currentFilters.forEach((current, index) => {
          if (newFilters[index]) {
            const newFilterItems = newFilters[index].querySelectorAll('li');
            const currentFilterItems = current.querySelectorAll('li');

            newFilterItems.forEach((newItem, itemIndex) => {
              if (currentFilterItems[itemIndex]) {
                const newCheckbox = newItem.querySelector('input[type="checkbox"], input[type="radio"]');
                const currentCheckbox = currentFilterItems[itemIndex].querySelector('input[type="checkbox"], input[type="radio"]');

                // Update checked and disabled state
                currentCheckbox.checked = newCheckbox.checked;
                currentCheckbox.disabled = newCheckbox.disabled;

                // Update the label content
                currentFilterItems[itemIndex].querySelector('label').innerHTML = newItem.querySelector('label').innerHTML;
              }
            });
          }
        });

        // Update product grid content
        const newProductGridContent = html_div.querySelector('.collection__product-grid').innerHTML;
        if (document.querySelector('.collection__product-grid')) {
          document.querySelector('.collection__product-grid').innerHTML = newProductGridContent;
        }

        // Update active filters
        const newActiveFiltersContent = html_div.querySelector('.active-filters').innerHTML;
        if (document.querySelector('.active-filters')) {
          document.querySelector('.active-filters').innerHTML = newActiveFiltersContent;
        }

        history.replaceState(null, null, '?' + queryString);

        console.log('After fetch: Filters and products updated');
      })
      .catch(error => console.error('Error:', error))
      .finally(() => {
        loading = false;
      });
  };

  document.querySelectorAll('.filter-form').forEach(form => {
    form.addEventListener('change', function(event) {
      const input = event.target;
      const currentParams = new URLSearchParams(window.location.search);
      const key = input.name;
      const value = input.value;

      if (input.type === 'checkbox') {
        if (input.checked) {
          currentParams.append(key, value);
        } else {
          const values = currentParams.getAll(key).filter(v => v !== value);
          currentParams.delete(key);
          values.forEach(v => currentParams.append(key, v));
        }
      } else if (input.type === 'radio') {
        currentParams.set(key, value);
      }

      const queryString = currentParams.toString();
      history.replaceState(null, null, '?' + queryString);

      const collectionHandle = form.dataset.collectionHandle;
      handleFilterUpdate(form, collectionHandle);
    });
  });
});